import { $global } from "./global.js";
import { $cookies } from "./cookies.js";
import axios from "axios";

const $session = 
{
    // 토큰 쿠키에 저장
    setCookies(accessToken, refreshToken)
    {
        $cookies.set("ACCESS_TOKEN", accessToken, "60s"); // keycloak 접근 토큰
        $cookies.set("REFRESH_TOKEN", refreshToken, "60s"); // keycloak 갱신 토큰
    },
    // 토큰 쿠키 삭제
    removeCookies()
    {
        $cookies.remove("ACCESS_TOKEN");
        $cookies.remove("REFRESH_TOKEN");
    },
    // 로그인 URL 설정
    setSignInUrl(siteNo, compNo)
    {
        let signInUrl = "/login?s=" + siteNo + "&c=" + compNo;
        sessionStorage.setItem("SIGNIN_URL", signInUrl);
    },
    // 토큰 만료시 이동할 로그인 URL 조회
    getSignInUrl()
    {
        let result = "";
        let siteNo = process.env.VUE_APP_SITE_NO;
        let compNo = process.env.VUE_APP_COMP_NO;
        let siteUrl = process.env.VUE_APP_SITE_URL;
        let accountSiteUrl = process.env.VUE_APP_ACCOUNT_URL;

        if (siteNo && compNo && siteUrl && accountSiteUrl) {
            let callbackUrl = siteUrl + "/login";
            let loginUrl = accountSiteUrl + "/login";
            let loginUrlParam = "?cb=" + callbackUrl + "&s=" + siteNo + "&c=" + compNo;
            result = loginUrl + loginUrlParam;
        } else {
            result = sessionStorage.getItem("SIGNIN_URL");
        }

        return result;
    },
    // 사용자 정보조회 URL
    getAccountInfo()
    {
        let siteNo = process.env.VUE_APP_SITE_NO;
        let compNo = process.env.VUE_APP_COMP_NO;
        let accountUrl = process.env.VUE_APP_ACCOUNT_URL;

        let accessToken = $cookies.get("ACCESS_TOKEN");
        let refreshToken = $cookies.get("REFRESH_TOKEN");
        let url = accountUrl + "/edit";
        let param = "?s=" + siteNo + "&c=" + compNo + "&a=" + accessToken + "&r=" + refreshToken;
        
        return url + param;
    },
    // 토큰에서 사용자정보 조회
    getUserInfo()
    {
        let result = {};
        let accessToken = $cookies.get("ACCESS_TOKEN");
        if (accessToken) {
            let jwt = $global.parseJwtToken(accessToken);
            result.NAME = jwt.name;
        }
        return result;
    },
    // 로그인 여부
    isLogin()
    {
        let result = false;
        let accessToken = $cookies.get("ACCESS_TOKEN");
        if (accessToken) {
            result = true;
        }
        return result;
    },
    // 갱신토큰 호출
    callRefreshToken()
    {
        let refreshToken = $cookies.get("REFRESH_TOKEN");
        let url = "/user-app/v1/login/refresh-token";
		let param = {"REFRESH_TOKEN": refreshToken};

		axios.post(url, param).then((response) => {
			if (response.status == 200) {
				let json = response.data;
				let accessToken = json.ACCESS_TOKEN;
				let refreshToken = json.REFRESH_TOKEN;
                this.setCookies(accessToken, refreshToken);
			}  
		});
    }
}

export {
    $session
}